import React, { useState, useEffect } from "react";

const useWindowSize = () => {
  const [size, setSize] = useState({ x: window.innerWidth, y: window.innerHeight });

  useEffect(() => {
    const handleResize = () => setSize({ x: window.innerWidth, y: window.innerHeight });

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
};

export default useWindowSize;
